import { isLoading, loading, Loading } from "../Loading";

export function fmap<T, R>(value: T | null | undefined, predicate: (v: T) => R) {
  if (value === null || value === undefined) {
    return null;
  }

  return predicate(value);
}

export function flmap<T, R>(value: T | Loading, predicate: (v: T) => R) {
  if (isLoading(value)) {
    return loading();
  }

  return predicate(value);
}
